<template>
  <div class="header-nav d-flex">
    <modal
      v-if="showModal"
      class="store-modal">
      <h2 slot="header" class="title mb-2">
        change region or store
      </h2>
      <div slot="body" class="body">
        <h3 class="mt-1 mb-2"><b>region:</b> {{storeInfo.region.toLowerCase()}}</h3>
        <select 
          v-if="regionList.length != 0"
          @input="
            event => {
              selectHandler(event.target.value, 'region');
            }
          ">
          <option>please select region</option>
          <option :value="'all regions'">all regions</option>
          <optgroup label="────────────────────────" />
          <option
            v-for="(option, index) in regionList"
            :value="[option.id, option.region_name]"
            :key="index"
          >
            {{option.region_name.toLowerCase()}}
          </option>
        </select>


        <hr style="margin: 10px -5px 10px -5px;" />
        <h3 class="mt-1 mb-2"><b>store:</b> {{storeInfo.name.toLowerCase()}}</h3>
        <select 
          v-if="storeList.length != 0"
          @input="
            event => {
              selectHandler(event.target.value, 'store');
            }
          ">
          <option>please select store</option>
          <option :value="'all stores'">all stores</option>
          <optgroup label="────────────────────────" />
          <option
            v-for="(option, index) in storeList"
            :value="[option.id, option.name]"
            :key="index"
          >
            {{option.name.toLowerCase()}}
          </option>
        </select>
      </div>
      <div slot="footer" class="modal-footer">
        <button class="action-button button" @click="selectHandler('','reset')">reset all</button>
        <button class="action-button button close" @click="toggleModal()">cancel</button>
      </div>
    </modal>

    <div class="bt-logo mr-2">
      <p>feedback</p>
      <small>powered by springbig</small>
    </div>
    <div class="data-wrapper">
      <div class="header-nav-1">
        <span class="text-1 mr-2">{{storeInfo.organization.toLowerCase()}}</span>
        <span class="text-1 mr-2">{{storeInfo.region.toLowerCase()}}</span>
        <span class="text-1 mr-2">{{storeInfo.name.toLowerCase()}}</span>
        <a
          id="chg-store-btn" 
          class="btn text-1"
          v-on:click="toggleModal();"
          >
          <span>change location</span>
        </a>
      </div>
      <div class="header-nav-2">
        <span class="text-2">
          <a
            id="dashboard-btn" 
            class="btn"
            :class="{'active': currentHeader == 'dashboard'}"
            v-on:click="handleHeaderClick('dashboard');"
            >
            <fai :icon="['fas', 'tachometer-alt']" class="mr-1" />dashboard
          </a>
        </span>
        <span class="text-2">
          <a
            id="analytics-btn" 
            class="btn"
            :class="{'active': currentHeader == 'analytics'}"
            v-on:click="handleHeaderClick('analytics');"
            >
            <fai :icon="['far', 'chart-bar']" class='mr-1' />scoring analytics
          </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { feedbackAPI } from "../../services/api/feedbackAPI"
import Modal from '../shared/Modal'
import Icons from '../shared/Icons'

export default {
  props: {
    currentHeader: String,
  },
  name: "HeaderNavPanel",
  components: {
    Modal,
    Icons
  },
  data() {
    return {
      showModal: false,
      storeList: [],
      regionList: [],
      storeInfo: {
        organization: '',
        region: 'all regions',
        name: 'all stores'
      }
    };
  },
  created() {
    this.getOrganizationName()
  },
  mounted() {
    if (localStorage.budtender_store_name) {
      this.storeInfo.name = localStorage.budtender_store_name
    }
    if (localStorage.budtender_region_name) {
      this.storeInfo.region = localStorage.budtender_region_name
    }
  },
  methods: {
    handleHeaderClick (event) {
      this.$emit('clickedHeader', event)
    },
    toggleModal: function() {
      if(this.storeList.length == 0) this.getStoreList()
      if(this.regionList.length == 0) this.getRegionList()
      this.showModal = !this.showModal
    },
    getStoreList: async function() {
      this.storeList = await feedbackAPI.GETBaseStoreList()
    },
    getRegionList: async function() {
      this.regionList = await feedbackAPI.GETRegionList()
    },
    getOrganizationName: async function() {
      this.storeInfo.organization = await feedbackAPI.GETOrganizationInfo()
    },
    selectHandler: function(option, type) {
      this.showModal = !this.showModal

      if (option == 'all regions') {
        localStorage.removeItem('budtender_region_id')
        localStorage.removeItem('budtender_region_name')
        this.storeInfo.region = option
      } else if (option == 'all stores') {
        localStorage.removeItem('budtender_store_id')
        localStorage.removeItem('budtender_store_name')
        this.storeInfo.name = option
      } else if (type == 'region') {
        localStorage.budtender_region_id = option.split(",")[0]
        localStorage.budtender_region_name = option.split(/,(.+)/)[1]
        this.storeInfo.region = option.split(/,(.+)/)[1]
      } else if (type == 'store') {
        localStorage.budtender_store_id = option.split(",")[0]
        localStorage.budtender_store_name = option.split(/,(.+)/)[1]
        this.storeInfo.name = option.split(/,(.+)/)[1]
      } else if (type == 'reset') {
        localStorage.removeItem('budtender_store_id')
        localStorage.removeItem('budtender_store_name')
        localStorage.removeItem('budtender_region_id')
        localStorage.removeItem('budtender_region_name')
        this.storeInfo.name = 'all stores'
        this.storeInfo.region = 'all regions'
      }
      
      this.$root.$emit("setStore")
    }
  }
}
</script>
